import { LEGAL_DOCUMENTS } from './documents.config';
import { LegalDocumentPage } from './legal-document-page';
import { resolveLocale } from './locale';

/** Unauthenticated /legal-notice route (ESCLOUD-78 / ESCLOUD-181). */
export function LegalNoticePage() {
    const config = LEGAL_DOCUMENTS.legalNotice;
    const locale = resolveLocale(config.locales);
    return (
        <LegalDocumentPage
            title={config.titles[locale]}
            version={config.version}
            effectiveDate={config.effectiveDate}
            contentType="legal-notice"
            locale={locale}
        />
    );
}
